import { styled } from '@a1s/ui';

export const UseDimensionsContainer = styled('div', {
  width: '100%',
});
